Ext.ns('mx.comp');

/**
 * Toolbar of buttons, mainly used for navigation (either vertical and horizontal)
 */
mx.comp.Toolbar = Ext.extend(Ext.Toolbar, {
    selected: null,
    vertical: false,
    minButtonWidth: 100,

    autoCreate: {cls: 'x-toolbar x-small-editor'}, // Separate autocreate property that not interfer with parent

    onRender: function(ct, position) {
        this.autoCreate.html =
            '<table cellspacing="0"' + (this.vertical ? ' style="width: 100%;"' : '') + '><tr></tr></table>';
        mx.comp.Toolbar.superclass.onRender.apply(this, arguments);
    },
    /**
     * Accepts an array of objects, that describe links to different screens
     * @param items
     */
    addNavigables: function(items) {
        this.buttons = [];
        Ext.each(
            items,
            function(item) {
                this.buttons.push({
                    xtype: 'mx_tbbutton',
                    text: item.title,
                    href: item.href,
                    name: item.name,
                    minWidth: this.minButtonWidth,
                    allowDepress: false,
                    pressed: item.name == this.selected,
                    onClick: item.onClick,
                });
            },
            this
        );
    },
    select: function(name) {
        this.selected = name;

        if (!this.items) return;

        this.items.each(function(item) {
            item.toggle(item.name == this.selected);
        }, this);
    },
    nextBlock: function() {
        var td = mx.comp.Toolbar.superclass.nextBlock.apply(this, arguments);

        if (this.vertical) {
            var tr = document.createElement('tr');
            var tbl = this.el.child('tbody', true);
            tbl.appendChild(tr);
            this.tr = tr;
        }

        return td;
    },
});

Ext.reg('mx_toolbar', mx.comp.Toolbar);

mx.comp.Toolbar.Button = Ext.extend(Ext.Toolbar.Button, {
    href: '#', // Actual link href
    name: '', // Key used for navigation & selecting active button
    layout: 'fit',
    template: new Ext.Template( // from Button.js with <button> changed to <a>
        '<table border="0" cellpadding="0" cellspacing="0" class="x-btn-wrap"><tbody><tr>',
        '<td class="x-btn-left"><i>&#160;</i></td><td class="x-btn-center"><em unselectable="on"><a style="text-decoration: none; color: #000; display: block;" class="x-btn-text" name="{1}">{0}</a></em></td><td class="x-btn-right"><i>&#160;</i></td>',
        '</tr></tbody></table>'
    ),
    buttonSelector: 'a:first',
    onRender: function() {
        this.type = this.href; // hack to insert href value to template
        mx.comp.Toolbar.Button.superclass.onRender.apply(this, arguments);
    },
    autoWidth: function() {
        mx.comp.Toolbar.Button.superclass.autoWidth.apply(this, arguments);
        if (this.el && this.minWidth && this.minWidth == '100%') {
            this.el.setWidth('100%');
        }
    },
    onClick: function(e) {
        // Here we don't need superclass behavior at all, only possible handlers
    },
});

Ext.reg('mx_tbbutton', mx.comp.Toolbar.Button);
